<template>
  <div class="w-full">
    <h2 class="text-secondary header-regular text-3xl">
      Upload a photo
    </h2>
    <h2 class="text-primary header-light text-sm">Say cheese...</h2>

    <label for="avatar">
      <input
        type="file"
        class="hidden"
        @change="updateFile"
        id="avatar"
        name="avatar"
      />

      <img
        v-if="currentUser.avatar"
        class="bg-cover mx-auto border-4 shadow-2xl border-white my-10 bg-pink-400 rounded-full h-40 w-40 object-cover"
        :src="currentUser.avatar"
        alt="Profile Image"
      />
      <img
        v-else
        class="bg-cover mx-auto border-4 shadow-2xl border-white my-10 bg-pink-400 rounded-full h-40 w-40 object-cover"
        src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw4HBhETBxIQFhUODREZFQ0VEREPDRETGBEiGBcRGBYYHSghGBonJx8VITEhJSkrLi4uGR8zODMsNygtLisBCgoKBQUFDgUFDisZExkrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrK//AABEIAOEA4QMBIgACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAUCAwYBB//EAEMQAAIBAgIECgUICQUAAAAAAAABAgMEBRESIUFRBhMiMVJhcZGhsTJCcoHRFGKCkrLB4fAjJCUzNFNjovEVFjVDwv/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8A+4gAAAAAAAAAAAAAAAAGFSapwbm8kk23uSAzBX2uM210v0NWGfRfIl3SyLAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUeJcJKNpnGly57ovkJ9cvhmVHCXG3Wqyo2jyhHNSmnrk9q7PM5wDt8GxKVe2nXxCcIR0nGMNSgkss3vbz1e4p8fx/wCWwdO0zUPWm9Tn1ZbF5lAegeE/D8XuMPy4qbcehLXB+7Z7iCAPoGDYzTxSGUeTNLlUn5p7UWp8toVpW1aM6TylB5pn0bC71X9hCpD1lrW6S1Nd4EwAAAAAAAAAAAAAAAAAAAAAAAAAAChx3HoWMJQt+VUya1Pkwe9vf1DhPi7w+ioW75dRPldCO/t3HEAeHoAAAAAAAJ+GYtWw3VbtOLlm4SWab81zGvDrGd9WS1qOlyp7luXWR6376Xty92sDvcIxqliSyjyZ7abfjF7UWp8spVHSmpUm1JSzUl6SZ9BwPEliVmpalKOqUd0t66nzgWQAAAAAAAAAAAAAAAAAAAAAeN6J6QMbq8RhFZ/0pJdstS8wOCxK7d7fzqdOXJ6orVFd2RGPD0Alpaoa35lta4HUq67h6C6PPP4IsMIw1WkFKquW/wCxbl1lkBW08Et4+npS7ZZeWRtWE2/8tfWn8SaAIf8Apdv/AC498vierDbeP/XH35vzJYA8hFRyUEktkUsoo4u4jo3M1unJeLO1OTxilxeJT65Zr3/jmBDLngnd/JsVUfVrLJ+1zxffq95TGy2qcRcwl0Jxfc0wPqIAAAAAAAAAAAAAAAAAAAAAVXCf/hK3ZD7aLUgY3T4zCKy/pTa7Us15AfOSfglvx9+tPmhrfu5vFruIBfcGqf6GpLfKK7ln94F0AAAAAAAAU/CK10qKqQ54apey/g/MuDyUVKDU1mnqcd6A4g8ZMxOydjc5c8ZZuMurc+tGm0p8bc0475wXfJID6dD0F2IyAAAAAAAAAAAAAAAAAAAAAYTSlBqXNt7DMjX8tG2fXkgPm1elxFaUehOUe3J5HR8H46OGrrnJ/d9xT41S4rEp9eTXv5/HMu8DX7Nh9L7TAngAAAAAAAAACn4Sr9Wpv57XfF/BEDg5S43G6K3Nv6sW14pE/hK/1an7b+y/iR+DVP8AWZz6EUl2t/h4gd6DCnLTgnvSZmAAAAAAAAAAAAAAAAAAAAi4j/D/AEkSjRdw0raS6s+7WBxvCWl+7n2p+a/9E7BV+zaf0vtM24ha/K7ZwzyekmpZZ5NP4Zm2hSVCjGMOaEUkBsAAAAAAAAAAFPwlX6tT9t+X4G7AqPFWCe2cm/dzLwXiScQtFfW2jN5cpNS3NfhmSaNP0Yw5tSXUuYC5or9DH2V5GwAAAAAAAAAAAAAAAAAAAAAAAp7qjxFbqfMai8aKavHRrSXzmBgAAAAAAAAAABMsKPL0pc2zrZhYQ0rn2Yv4FoAAAAAAAAAAAAAAAAAAAAAAAAAK3EoaM1Lf5osjTcUuMpNd3aBUANaOoAAAAAAAAypU3VmlD/CAnYdT0IN7/Jflk0whHRglHYZgAAAAAAAAAAAAAAAAAAAAAAAAACNeXdO0paVw8ls3t7ktoEHEZaNz2xXf1mkw+Vf6hBy0ck81lnsX3mjjHQnlV1rZICUDCFRS9BozAAGupWhT2/RQGbZKwerxs6nVo5eJTVq7q9S6PxNuH4isPnlVT0Z5ZyXPHLq2rWB1ANdKpGrBSpNNPma2mwAAAAAAAAAAAAAAAAAAAAAAAEa6vKdtBurKKyjnlmtJ9i2gY4hewsqOlV5/Vjtkzjby7nd1nKq+yPqxW5GWIXkr25cpdkY+rFbiMBd4V/Br2n5kqcVKGUyHhM1K2y2qTz9/MTgIFa3dL0Na/uRrVR733sszVUoQls+kgILm5bX3sxJUrPoPvMPksurvCtBGvPV9/wBxYq0nvRBxGKjNRzzazz6s9gRlheJSw+fJ1xfpQ+9bmdhb143NFSpPNPmf52nAllg2IuyrZT9CcuV819JAdkDXTqxqQzpNNb0014GwAAAAAAAAAAAAAAAr7/FaVlqm85dBc/v3HPXuOVrnVB6EejH0vfLn7sgOmusQo2n8RNJ7ueXciouuEuy1h75fBfE548AmXGKV7n0qkst0eQvAhgAAABnTqOlPODyZa2uJKrqq8l9L1X8CnAHTHpRWd7Ohqnrj0d3YXcJqrBODzT5gMjGUlGGc2kusxr1lQg5T/wAvciiubmdzPOfNsj6qAm3eJbLf6/wK08AAAAZ06jpTzpNxfSTal4FjbY9cUPTamvnLld6KsAdTbcIqVTVcJxf14d61+BbUa0K0M6MlJb00zgDOlVlQnnSk4vpJtAfQQcvY8Ip08ldrSXSWSn3cz8C/tL2leQzt5J71tXagJIAAAADCclCLc2klrbexHNYpjrqZxsm1HbPmlLs3LxPOEeIOpWdOk+TD0vnS3di8ykA9PAAAAAAAAAAAAAFlg9fluE9utdu389RWmy3qcVWjLdIDfiVfjblrZDUu3a/zuIgAAAAAAAAAAAADKnUdKadJtNc0k8pGIA6PC8e08o3uSeyp6r9pbO06E+dl7wexNxmqVw9T1Qb2PodgHTg8zAHz+tPja0pdKTfe8zAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD1PR1w1PZLczwAdB/uTqPCgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAH//2Q=="
        alt="Profile Image"
      />

    </label>

    <div class="w-full mt-10">
        <button @click="changeSlide()" class="h-16 w-full bg-primary text-white rounded mb-4">Next</button>
      </div>
      
  </div>
</template>


<script>
import {upload, listenToState, putFire} from "../../firestore/utils";
import { Base64 } from 'js-base64';
import { bus } from '../../main'

export default {
    computed:{
        currentUser(){
            return this.$store.state.currentUser
        }
    },
  methods: {
    changeSlide(){
      bus.$emit("changeSlide", {slide: 2})
    },
    async updateFile(event) {
      const userId = await listenToState()
      const base64 = await this.generateBase64(event.target.files[0]);
      console.log("base64", base64)
      const _upload = await upload({
        child: `avatar-${userId}`,
        base: base64
      })
      await this.updateUser(userId, _upload)

    },
    generateBase64(file) {
      return new Promise(async (resolve, reject) => {
        try {
          Base64.extendString();
          resolve(Base64.encode(file));
        } catch (e) {
          reject(e);
        }
      });
    },
    async updateUser(userId, _upload){
      console.log("_upload", _upload)
      putFire({collection: 'users', doc: userId, body: {
        avatar: _upload
      }})
    },
  },
  created (){
    bus.$on('changeSlide', (payload) => {
      this.slide = payload.slide;
    })
  }
};
</script>